import { useQuery } from "@tanstack/react-query";
import { procurementPipelineApi } from "../api/procurementPipeline";

export const useFetchMaterialDelayStatistics = ({ quickFilters }: { quickFilters: any }) => {
    const { data, isFetching, isPending, isError, refetch } = useQuery({
        //     queryKey: ["material-request-delay-statistics", quickFilters.workstream, quickFilters.site, quickFilters.programme, quickFilters.region],
        //     queryFn: () => {
        //     return procurementPipelineApi.fetchMaterialDelayStatistics({
        //     workstream_id: quickFilters.workstream || null,
        //     site_id: quickFilters.site || null,
        //     programme_id: quickFilters.programme || null,
        //     region_id: quickFilters.region || null,
        //   });
        //     }
        queryKey: ["material-request-delay-statistics"],
        queryFn: () => {
            return procurementPipelineApi.fetchMaterialDelayStatistics();
        }
    });
    return {
        delayedMaterials: data?.data?.delayed_materials || 0,
        activeMaterialRequests: data?.data?.active_material_requests || 0,
        materialsDelayedRate: data?.data?.materials_delayed_rate || 0,
        isPending,
        isFetching,
        isError,
        refetch
    };
};

export const useFetchResourceDelayStatistics = ({ quickFilters }: { quickFilters: any }) => {
    const { data, isFetching, isPending, isError, refetch } = useQuery({
        // queryKey: ["resource-request-delay-statistics", quickFilters.workstream, quickFilters.site, quickFilters.programme, quickFilters.region],
        // queryFn: () => procurementPipelineApi.fetchResourceDelayStatistics({
        //     workstream_id: quickFilters.workstream || null,
        //     site_id: quickFilters.site || null,
        //     programme_id: quickFilters.programme || null,
        //     region_id: quickFilters.region || null,
        // }),
        queryKey: ["resource-request-delay-statistics"],
        queryFn: () => procurementPipelineApi.fetchResourceDelayStatistics(),
    });

    return {
        delayedResources: data?.data?.delayed_resources || 0,
        totalActiveResources: data?.data?.total_active_resources || 0,
        resourceDelayedRate: data?.data?.resource_delayed_rate || 0,
        isPending,
        isFetching,
        isError,
        refetch
    };
};
